import avalanchec from '@exodus/avalanchec-meta'
import bnbmainnet from '@exodus/bnbmainnet-meta'
import bsc from '@exodus/bsc-meta'
import cardano from '@exodus/cardano-meta'
import ethereum from '@exodus/ethereum-meta'
import fantommainnet from '@exodus/fantommainnet-meta'
import litecoin from '@exodus/litecoin-meta'
import matic from '@exodus/matic-meta'
import tronmainnet from '@exodus/tronmainnet-meta'

const allAssets = [
  ...avalanchec,
  ...bnbmainnet,
  ...bsc,
  ...cardano,
  ...ethereum,
  ...fantommainnet,
  ...litecoin,
  ...matic,
  ...tronmainnet,
]

export const findPrimaryAsset = ({ combinedAssetName, primaryAssetName }) => {
  const asset = allAssets.find((asset) => asset.name === primaryAssetName)
  if (!asset) {
    throw new Error(
      `Primary Asset ${primaryAssetName} not fund for combined asset ${combinedAssetName}`
    )
  }

  return asset
}
